<app-menu-bar></app-menu-bar>
<div class="processamento-container">
    <div style="text-align: center">Processamento Lista</div>  
    <div class="table-container">
        <p-table
        [value]="processamentos"
        styleClass="carga-table"
        [tableStyle]="{ 'min-width': '52rem' }"
        [paginator]="true"
        [rows]="20"
        [rowsPerPageOptions]="[10, 20, 50, 100]"
        [showCurrentPageReport]="true"
        currentPageReportTemplate="{first}-{last} de {totalRecords}">
            <ng-template pTemplate="header">
                <tr>
                    <th class="carga-col-hide-sm" pSortableColumn="id">
                        <div class="flex justify-content-between align-items-center">
                          <div class="flex justify-content-between align-items-center">
                            Id
                          </div>
                          <div class="flex justify-content-between align-items-center">
                            <p-sortIcon field="id"></p-sortIcon>
                            <p-columnFilter
                              type="text"
                              field="id"
                              display="menu"
                              matchMode="contains"
                              [showMatchModes]="true"
                              [showOperator]="true"
                              [showAddButton]="true"
                            ></p-columnFilter>
                          </div>
                        </div>
                      </th>

                      <th pSortableColumn="processamentoArquivo.nomeArquivo">
                        <div class="flex justify-content-between align-items-center">
                          <div class="flex justify-content-between align-items-center">
                            Arquivo
                          </div>
                          <div class="flex justify-content-between align-items-center">
                            <p-sortIcon field="processamentoArquivo.nomeArquivo"></p-sortIcon>
                            <p-columnFilter
                              type="text"
                              field="processamentoArquivo.nomeArquivo"
                              display="menu"
                              matchMode="contains"
                              [showMatchModes]="true"
                              [showOperator]="true"
                              [showAddButton]="true"
                            ></p-columnFilter>
                          </div>
                        </div>
                      </th>

                      <th pSortableColumn="nomeLista">
                        <div class="flex justify-content-between align-items-center">
                          <div class="flex justify-content-between align-items-center">
                            Nome Lista
                          </div>
                          <div class="flex justify-content-between align-items-center">
                            <p-sortIcon field="nomeLista"></p-sortIcon>
                            <p-columnFilter
                              type="text"
                              field="nomeLista"
                              display="menu"
                              matchMode="contains"
                              [showMatchModes]="true"
                              [showOperator]="true"
                              [showAddButton]="true"
                            ></p-columnFilter>
                          </div>
                        </div>
                      </th>

                      <th pSortableColumn="dataInicio">
                        <div class="flex justify-content-between align-items-center">
                          <div class="flex justify-content-between align-items-center">
                            Início
                          </div>
                          <div class="flex justify-content-between align-items-center">
                            <p-sortIcon field="dataInicio"></p-sortIcon>
                            <p-columnFilter
                              type="text"
                              field="dataInicio"
                              display="menu"
                              matchMode="contains"
                              [showMatchModes]="true"
                              [showOperator]="true"
                              [showAddButton]="true"
                            ></p-columnFilter>
                          </div>
                        </div>
                      </th>

                      <th pSortableColumn="dataTermino">
                        <div class="flex justify-content-between align-items-center">
                          <div class="flex justify-content-between align-items-center">
                            Termino
                          </div>
                          <div class="flex justify-content-between align-items-center">
                            <p-sortIcon field="dataTermino"></p-sortIcon>
                            <p-columnFilter
                              type="text"
                              field="dataTermino"
                              display="menu"
                              matchMode="contains"
                              [showMatchModes]="true"
                              [showOperator]="true"
                              [showAddButton]="true"
                            ></p-columnFilter>
                          </div>
                        </div>
                      </th>

                      <th pSortableColumn="quantidadeLinhas">
                        <div class="flex justify-content-between align-items-center">
                          <div class="flex justify-content-between align-items-center">
                             Quantidade Linhas
                          </div>
                          <div class="flex justify-content-between align-items-center">
                            <p-sortIcon field="quantidadeLinhas"></p-sortIcon>
                            <p-columnFilter
                              type="text"
                              field="quantidadeLinhas"
                              display="menu"
                              matchMode="contains"
                              [showMatchModes]="true"
                              [showOperator]="true"
                              [showAddButton]="true"
                            ></p-columnFilter>
                          </div>
                        </div>
                      </th>
                      <th>Status</th>
                      <th class="carga-actions">Operação</th>
                </tr>
            </ng-template>

            <ng-template pTemplate="body" let-dados>
                <tr>  
                    <td class="carga-col-hide-sm">{{ dados.id }}</td>
                    <td>{{ dados.processamentoArquivo.nomeArquivo }}</td> 
                    <td>{{ dados.nomeLista }}</td>
                    <td>{{ dados.dataInicio | date : "yyyy-MM-dd HH:mm:ss" }}</td>
                    <td>{{ dados.dataTermino | date : "yyyy-MM-dd HH:mm:ss" }}</td>
                    <td>{{ dados.quantidadeLinhas }}</td>
                    <td>
                      <i [class]="getIconClass(dados.statusLerLista)"></i>&nbsp;Leitura Dados<BR>
                      <i [class]="getIconClass(dados.statusConverteLista)"></i>&nbsp;Conversão Lista<BR>
                      <i [class]="getIconClass(dados.statusProcessamentoRegistros)"></i>&nbsp;Processamento Registros&nbsp;({{ dados.percentualProcessamentoRegistros }}%)<BR>
                      <i [class]="getIconClass(dados.statusProcessamentoDocumentos)"></i>&nbsp;Processamento Documentos&nbsp;({{ dados.percentualProcessamentoDocumentos }}%)<BR>
                      <i [class]="getIconClass(dados.statusVerificaProcessamento)"></i>&nbsp;Verifica Processamento&nbsp;({{ dados.percentualChecagemStatus }}%)<BR>
                    </td>
                    <td class="carga-actions">
                      <p-button
                        icon="pi pi-external-link"
                        styleClass="p-button-rounded p-button-secondary p-button-text"
                        pTooltip="Detalhar"
                        (click)="detalhaLista(dados)"
                      ></p-button>
                      <p-button
                        icon="pi pi-file-export"
                        styleClass="p-button-rounded p-button-secondary p-button-text"
                        pTooltip="Exportar Erros"
                        (click)="exportarDados(dados)"
                      ></p-button>
                      <p-button
                        icon="pi pi-bolt"
                        styleClass="p-button-rounded p-button-secondary p-button-text"
                        pTooltip="Reprocessar as falhas"
                        (click)="reprocessar(dados)"
                      ></p-button>
                      <p-button
                        icon="pi pi-times"
                        styleClass="p-button-rounded p-button-secondary p-button-text"
                        pTooltip="Cancelar Processamento"
                        (click)="cancelarProcessamento(dados)"
                      ></p-button>
                    </td>
                </tr>
        
            </ng-template>
            <ng-template pTemplate="emptymessage">
                <tr>
                    <td class="carga-empty" colspan="8">
                        <div class="carga-empty__content">
                            <i class="pi pi-inbox"></i>
                            <span>Nenhum registro encontrado</span>
                        </div>
                    </td>
                </tr>
            </ng-template>
        </p-table>

    </div>



    